var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.isMobile)?_c('HomeM'):_c('HomeP')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }